import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { environment } from '../environments/environment';
import { AuthGuard, RedirectGuard } from './shared';

let routes: Routes = [
    { path: '', loadChildren: './layout/layout.module#LayoutModule', canActivate: [AuthGuard] },
    { path: 'login', loadChildren: './login/login.module#LoginModule' },
    { path: 'newAccountRequest', loadChildren: './new-account-request/new-account-request.module#NewAccountRequestModule' },
    { path: '**', redirectTo: '' }
];
if (!environment.showCreateNewAccountRequest) { routes = routes.filter(x => x.path !== 'newAccountRequest'); }

@NgModule({
    imports: [
        RouterModule.forRoot(routes)
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule { }
